/**
 * Centralized localStorage key definitions.
 */
export const storageKeys = {
  emailForSignIn: "emailForSignIn",
  cookieConsent: "cookie-consent",
} as const;

export type ConsentState = "undecided" | "accepted" | "rejected";

export interface ConsentData {
  analytics: boolean;
  timestamp: number;
  version: number;
}

const CONSENT_VERSION = 1;

export function getConsent(): ConsentState {
  try {
    const raw = localStorage.getItem(storageKeys.cookieConsent);
    if (!raw) return "undecided";
    const data: ConsentData = JSON.parse(raw);
    if (data.version !== CONSENT_VERSION) return "undecided";
    return data.analytics ? "accepted" : "rejected";
  } catch {
    return "undecided";
  }
}

export function setConsent(accepted: boolean): void {
  const data: ConsentData = {
    analytics: accepted,
    timestamp: Date.now(),
    version: CONSENT_VERSION,
  };
  localStorage.setItem(storageKeys.cookieConsent, JSON.stringify(data));
}
